// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonStack {
    margin: 0;
}

.baseDialogContent {
    margin: 0;
    padding: 0;
    max-height: 100%;
    flex: 1 1 auto;
    overflow: hidden;
}

.buttonStack > button {
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/fileexplorer/fileexplorer.dialog.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".buttonStack {\n    margin: 0;\n}\n\n.baseDialogContent {\n    margin: 0;\n    padding: 0;\n    max-height: 100%;\n    flex: 1 1 auto;\n    overflow: hidden;\n}\n\n.buttonStack > button {\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
